module.exports = __webpack_public_path__ + "assets/281f69cf83dfd6ea98f90ee9ebdc4443.svg";